module.exports = __webpack_public_path__ + "img/pro1.d9bd92d7.png";